
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { PortService } from 'src/app/core-services/port.service';
import { Port } from 'src/app/models/Port';
import { AuthService } from 'src/app/core-services/auth.service';
import { Router } from '@angular/router';
import { UserRole, PlanSubcriptions } from 'src/app/Enum/Enum';
import { ToastrService } from 'ngx-toastr';
import { MenuItem } from 'primeng/api';
import gsap from 'gsap';

declare global {
    interface Window { THREE: any; ResizeObserver: any }
}

// window.THREE = window.THREE || {};
@Component({
    selector: 'three-header-component',
    templateUrl: './three-header.component.html',
    styleUrls: ['./three-header.component.scss']
})
export class ThreeHeaderComponent implements OnInit {
    container = null;
    renderer = null;
    camera = null;
    scene = null;
    backgroundElement = null;
    resizeObserver = null;
    w = window.innerWidth;
    h = window.innerHeight;
    isMobile =  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    mousePosition = {
          x: 0.5,
          y: 0.5,
  };

    geometry1 = null;
    material1 = null;
    wavesMesh = null;
    animationFrameId = null;
    fov = 45;
    clock = new window.THREE.Clock();
    mouse = new window.THREE.Vector2();

    constructor() {
      this.render = this.render.bind(this);
      this.onWindowResize = this.onWindowResize.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleTouchMove = this.handleMouseMove.bind(this);
    }

     onWindowResize() {
          this.w = window.innerWidth;
          this.h = document.querySelector('.bg-image').clientHeight;
          this.renderer.setSize(this.w, this.h);
          this.camera.aspect = this.w / this.h;
          this.camera.updateProjectionMatrix();
      }

      handleTouchMove (e) {
          const touch = e.touches[0];
          this.mousePosition.x = touch.pageX / this.w;
          this.mousePosition.y = touch.pageY / this.h;
      };

      handleMouseMove (e)  {
          this.mousePosition.x = e.pageX / this.w;
          this.mousePosition.y = e.pageY / this.h;
      };

    render() {
              this.material1.uniforms.uTime.value = this.clock.getElapsedTime();

              if (!this.isMobile) {
                const cameraY = this.camera.position.y;

                const y = cameraY < 0.4 ? cameraY : this.mousePosition.y * 0.3;

                gsap.to(this.camera.position, {
                  x: (this.mousePosition.x - 0.5) * 1,
                  y,
                  z: this.mousePosition.y *  0.9,
                  duration: 0.44,
                  ease: 'circ.inOut'
                });
              }

              this.camera.lookAt(this.wavesMesh.position);

              this.renderer.render(this.scene, this.camera);
              this.animationFrameId = requestAnimationFrame(this.render);
      }

    ngOnDestroy() {
      if (this.renderer) this.renderer.dispose();
      if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.backgroundElement)
      }

      cancelAnimationFrame(this.animationFrameId);


      // Isolate into util
      const cleanMaterial = material => {
        material.dispose()

        // dispose textures
        for (const key of Object.keys(material)) {
          const value = material[key]
          if (value && typeof value === 'object' && 'minFilter' in value) {
            value.dispose()
          }
        }
      }

      if (this.scene) {
      this.scene.traverse(object => {
        if (!object.isMesh) return

        object.geometry.dispose()

        if (object.material.isMaterial) {
          cleanMaterial(object.material)
        } else {
          for (const material of object.material) cleanMaterial(material)
        }
      })
      }


      window.removeEventListener('resize', this.onWindowResize);
      // document.body.removeEventListener('touchmove', this.handleTouchMove);
      document.body.removeEventListener('mousemove', this.handleMouseMove);
    }

    ngOnInit() {}

    ngAfterViewInit() {
      if (window.ResizeObserver) {
        this.resizeObserver = new window.ResizeObserver(this.onWindowResize);
      }

      this.backgroundElement = document.querySelector('.bg-image');

      const init = () => {
          this.container = document.getElementById('three-container');
          this.scene = new window.THREE.Scene();
          this.camera = new window.THREE.PerspectiveCamera(75, this.w / this.h, 0.1, 100);
          this.camera.position.set(1, 1, 1);
          if (this.isMobile) {
            this.camera.position.y = 1.45;
          }
          this.scene.add(this.camera);
          this.scene.fog = new window.THREE.Fog("#003A66", 0, 4);
          this.h = this.backgroundElement.clientHeight;


          this.geometry1 = new window.THREE.PlaneGeometry(7, 7, 512, 512);
          this.material1 = new window.THREE.ShaderMaterial({
              fog: true,
              // wireframe: true,
              uniforms: {
                fogColor:    { type: "c", value: this.scene.fog.color },
                fogNear:     { type: "f", value: this.scene.fog.near },
                fogFar:      { type: "f", value: this.scene.fog.far },

                uTime: { value: 0 },

                // big waves
                uBigWavesElevation: { value: 0.04 },
                uBigWavesFrequency: { value: new window.THREE.Vector2(2.86, 1.15) },
                uSpeed: { value: 0.4 },

                uDepthColor: { value: new window.THREE.Color("#003A66") },
                uSurfaceColor: { value: new window.THREE.Color("#186691") },

                uColorOffset: { value: 0.25 },
                uColorMultiplier: { value: 2 },

                uSmallWavesElevation: { value: 0.12 },
                uSmallWavesFrequency: { value: 3.0 },
                uSmallWavesSpeed: { value: 0.2 },
                uSmallIterations: { value: 4.0 },
              },
              vertexShader: `
              uniform float uBigWavesElevation;
              uniform vec2 uBigWavesFrequency;
              uniform float uTime;
              uniform float uSpeed;

              uniform float uSmallWavesElevation;
              uniform float uSmallWavesFrequency;
              uniform float uSmallWavesSpeed;
              uniform float uSmallIterations;


              varying float vElevation;

              // Classic Perlin 3D Noise
              // by Stefan Gustavson
              //
              vec4 permute(vec4 x)
              {
                  return mod(((x*34.0)+1.0)*x, 289.0);
              }
              vec4 taylorInvSqrt(vec4 r)
              {
                  return 1.79284291400159 - 0.85373472095314 * r;
              }
              vec3 fade(vec3 t)
              {
                  return t*t*t*(t*(t*6.0-15.0)+10.0);
              }

              float cnoise(vec3 P)
              {
                  vec3 Pi0 = floor(P); // Integer part for indexing
                  vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
                  Pi0 = mod(Pi0, 289.0);
                  Pi1 = mod(Pi1, 289.0);
                  vec3 Pf0 = fract(P); // Fractional part for interpolation
                  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
                  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
                  vec4 iy = vec4(Pi0.yy, Pi1.yy);
                  vec4 iz0 = Pi0.zzzz;
                  vec4 iz1 = Pi1.zzzz;

                  vec4 ixy = permute(permute(ix) + iy);
                  vec4 ixy0 = permute(ixy + iz0);
                  vec4 ixy1 = permute(ixy + iz1);

                  vec4 gx0 = ixy0 / 7.0;
                  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
                  gx0 = fract(gx0);
                  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
                  vec4 sz0 = step(gz0, vec4(0.0));
                  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
                  gy0 -= sz0 * (step(0.0, gy0) - 0.5);

                  vec4 gx1 = ixy1 / 7.0;
                  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
                  gx1 = fract(gx1);
                  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
                  vec4 sz1 = step(gz1, vec4(0.0));
                  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
                  gy1 -= sz1 * (step(0.0, gy1) - 0.5);

                  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
                  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
                  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
                  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
                  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
                  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
                  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
                  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);

                  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
                  g000 *= norm0.x;
                  g010 *= norm0.y;
                  g100 *= norm0.z;
                  g110 *= norm0.w;
                  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
                  g001 *= norm1.x;
                  g011 *= norm1.y;
                  g101 *= norm1.z;
                  g111 *= norm1.w;

                  float n000 = dot(g000, Pf0);
                  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
                  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
                  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
                  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
                  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
                  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
                  float n111 = dot(g111, Pf1);

                  vec3 fade_xyz = fade(Pf0);
                  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
                  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
                  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x);
                  return 2.2 * n_xyz;
              }


              void main() {
                  vec4 modelPosition = modelMatrix * vec4(position, 1.0);

                  float elevation = sin(modelPosition.x * uBigWavesFrequency.x + uTime * uSpeed) *
                                    sin(modelPosition.z * uBigWavesFrequency.y + uTime * uSpeed) *
                                    uBigWavesElevation;


                  // elevation += -abs(cnoise(vec3(modelPosition.xz * 3.0, uTime * 0.2)) * 0.15);
                  // elevation += cnoise(vec3(elevation) * 2.0);

                  // 4.0 is where uSmallIterations used to be

                  #pragma unroll_loop_start
                  for (float i = 1.0; i <= 4.0; i++) {
                      elevation += -abs(cnoise(vec3(modelPosition.xz * uSmallWavesFrequency * i, uTime * uSmallWavesSpeed)) * uSmallWavesElevation / i);
                  }
                  #pragma unroll_loop_end

                  modelPosition.y += elevation;

                  vec4 viewPosition = viewMatrix * modelPosition;
                  vec4 projectedPosition = projectionMatrix * viewPosition;


                  gl_Position = projectedPosition;

                  // varyings
                  vElevation = elevation;
              }
              `,
              fragmentShader: `
                uniform vec3 fogColor;
                uniform float fogNear;
                uniform float fogFar;

                uniform vec3 uDepthColor;
                uniform vec3 uSurfaceColor;

                uniform float uColorOffset;
                uniform float uColorMultiplier;

                varying float vElevation;

                void main() {
                    float mixStrength = (vElevation + uColorOffset) * uColorMultiplier;

                    vec3 color = mix(uDepthColor, uSurfaceColor, mixStrength);
                    gl_FragColor = vec4(color, 1.0);

                    #ifdef USE_FOG
                      #ifdef USE_LOGDEPTHBUF_EXT
                          float depth = gl_FragDepthEXT / gl_FragCoord.w;
                      #else
                          float depth = gl_FragCoord.z / gl_FragCoord.w;
                      #endif
                      float fogFactor = smoothstep( fogNear, fogFar, depth );
                      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
                    #endif
                }
              `,

          });

          this.wavesMesh = new window.THREE.Mesh(this.geometry1, this.material1);
          this.wavesMesh.rotation.x = -Math.PI * 0.5;
          this.scene.add(this.wavesMesh);
          this.renderer = new window.THREE.WebGLRenderer({
            antialias: true
          });

          this.renderer.setSize(this.w, this.h);
          this.renderer.setClearColor(new window.THREE.Color('#003A66'));
          this.renderer.setPixelRatio(1);
          this.container.appendChild(this.renderer.domElement);

          if (window.ResizeObserver) {
            this.resizeObserver.observe(this.backgroundElement)
          }

          window.addEventListener('resize', this.onWindowResize);
      }

      init();
      this.render();

      // document.body.addEventListener('touchmove', this.handleTouchMove, false);
      document.body.addEventListener('mousemove', this.handleMouseMove)
    }
}
